module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.calendar) ? _c('div', {
    staticClass: "calendar",
    class: {
      'calendar-ongoing': _vm.eventStatus.currentEvent != null
    }
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.eventStatus.currentEvent ? _vm.calendar.color : null
    })
  }, [_c('h1', [_vm._v(_vm._s(_vm.calendar.title) + " " + _vm._s(_vm.eventStatus.currentEvent ? 'Varattu' : 'Vapaa'))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "info-col"
  }, [_c('ot-event-info', {
    attrs: {
      "event-status": _vm.eventStatus
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "calendar-col"
  }, [_c('ot-pikaday')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('ot-event-list', {
    attrs: {
      "calendar": _vm.calendar,
      "today-events": _vm.todayEvents
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3150b901","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/components/OtCalendar.vue
// module id = 240
// module chunks = 0